<template>
	<section ref="sectionRef"
			 class="hero-text-picture flex-module">
		<div class="container-fluid">
			<div class="row">
				<div class="col-xs-12 col-md-7">
					<h1 ref="titleRef"
						class="hero-title">
						{{ item.title }}
					</h1>

					<BaseRichText :data="item.intro" />

				</div>
				<div class="col-xs-12 col-md-5">
					<!-- <baseVideo :data="data stuff here"
									   :dont-play="true" /> -->
					<basePicture :image="item.image"
								 sizes="xs:100vw md:100vw lg:50vw xl:50vw 2xl:50vw 3xl:50vw"
								 loading="eager" />
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
import debounceFn from 'debounce-fn'

const props = defineProps({
	data: {
		type: Object,
		required: true
	}
})

const { gsap, ScrollTrigger, SplitText } = useGsap()
const { $bus } = useNuxtApp()
const metaStore = useMetaStore()
const splitlines = reactive({})
const revealDelay = metaStore.transitionDuration ? metaStore.getDelay : 500
const triggers = {}
let $q

const sectionRef = ref(null)
const titleRef = ref(null)

const item = computed(() => props.data?.item)

function animRevealTitle() {
	if (Object.prototype.hasOwnProperty.call(splitlines, 'innerSplit')) {
		revertText()
	}

	document.fonts.ready.then(() => {
		splitlines.outerSplit = new SplitText(titleRef.value, {
			type: 'lines',
			linesClass: 'split-parent'
		})

		splitlines.innerSplit = new SplitText($q('.split-parent'), {
			type: 'lines',
			linesClass: 'split-child'
		})

		gsap.set($q('.split-parent'), {
			overflow: 'hidden',
			position: 'relative',
		})

		gsap.set($q('.split-child'), {
			yPercent: 100,
		})

		gsap.set($q('.hero-title'), {
			autoAlpha: 1
		})

		delay(revealDelay).then(() => {
			triggers.revealTitle = ScrollTrigger.create({
				id: 'animRevealTitle',
				trigger: sectionRef.value,
				start: 'top bottom',
				onEnter: () => {
					gsap.to(splitlines.innerSplit.lines, {
						yPercent: 0,
						duration: 1.5,
						stagger: 0.2,
						ease: 'expo.out',
						onComplete: () => {
							// console.log('animRevealTitle complete')
							// revertText
						}
					})
				}
			})
		})
	})
}

const revertText = debounceFn((safe) => {
	nextTick(() => {
		splitlines.outerSplit.revert()
		splitlines.innerSplit.revert()
	})
}, { wait: 100 })


function initAnims() {
	$q = gsap.utils.selector(sectionRef.value)

	animRevealTitle()
}

onMounted(() => {
	useAnims(initAnims, triggers)

	$bus.$on('window-resized', revertText)
})

onBeforeUnmount(() => {
	$bus.$off('window-resized', revertText)
})
</script>

<style lang="scss" scoped>
.hero-title {
	@include textH4;
}

.hero-text-picture {
	position: relative;
	margin-top: calc(20vmin - 1.5rem);
	margin-bottom: 14vh;

	@include for-devices-above(md) {
		margin-top: calc(15vh - 3rem);
		margin-bottom: 14vh;
	}


	:deep(p) {
		font-weight: bold;
	}
}

:deep(picture) {
	@include rounded-corners;
}
</style>